import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "control" }

import { computed } from "vue";
import VueSelect, { type Option } from "vue3-select-component";
import { snakeCase } from "lodash-es";

interface Props {
  label: string;
  modelValue: Option<string>[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'multi-select-generic',
  props: {
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Extract just the values for modelValue (vue3-select-component expects values, not Options)
const selectedValues = computed(() => props.modelValue.map((opt) => opt.value));

// Methods
function handleOptionCreated(value: string) {
  emit("update:modelValue", [...props.modelValue, { value, label: value }]);
}

// For taggable selects, new values are strings that become both value and label
function handleValueChange(values: string | string[] | null | undefined) {
  if (values == null) {
    emit("update:modelValue", []);
    return;
  }
  // vue3-select-component emits array for isMulti
  const valuesArray = Array.isArray(values) ? values : [values];
  const selectedOptions = valuesArray.map((v) => {
    // Try to find existing option, or create new one for tagged values
    const existing = props.modelValue.find((opt) => opt.value === v);
    return existing ?? { value: v, label: v };
  });
  emit("update:modelValue", selectedOptions);
}

// Computed properties
const inputId = computed(() => {
  return snakeCase(props.label);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "label",
      for: inputId.value
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(VueSelect), {
        isMulti: true,
        isTaggable: true,
        inputId: inputId.value,
        options: __props.modelValue as any,
        modelValue: selectedValues.value,
        "onUpdate:modelValue": handleValueChange,
        onOptionCreated: handleOptionCreated
      }, null, 8, ["inputId", "options", "modelValue"])
    ])
  ]))
}
}

})